// strings should be unique across reducers so namespace them with the reducer name

export const LOGIN_CLEAR = 'auth.LOGIN_CLEAR';
export const LOGIN_SUCCESS = 'auth.LOGIN_SUCCESS';
export const LOGIN_FAILED = 'auth.LOGIN_FAILED';
export const LOGOUT_SUCCESS = 'auth.LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'auth.LOGOUT_FAILED';
